'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    TimePicker: ()=>TimePicker
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_Menu_index_cjs_namespaceObject = require("../Menu/index.cjs");
const external_TimePicker_variants_cjs_namespaceObject = require("./TimePicker.variants.cjs");
const external_utils_cjs_namespaceObject = require("./utils.cjs");
const TimePicker = ({ interval = 30, value, onValueChange, startTime = {
    hour: 12,
    minute: 0,
    meridiem: 'AM'
}, endTime = external_utils_cjs_namespaceObject.DEFAULT_END_TIME, preventUnselect = false, groupClassName })=>{
    const { current: isValueControlled } = (0, external_react_namespaceObject.useRef)(void 0 !== value);
    const [internalValue, setInternalValue] = (0, external_react_namespaceObject.useState)();
    const currentValue = isValueControlled ? value : internalValue;
    const timeOptions = (0, external_react_namespaceObject.useMemo)(()=>(0, external_utils_cjs_namespaceObject.generateTimeOptions)(interval, startTime, endTime), [
        interval,
        startTime,
        endTime
    ]);
    const handleTimeSelection = (0, external_react_namespaceObject.useCallback)((time)=>()=>{
            const newValue = (0, external_utils_cjs_namespaceObject.timeIsEqual)(currentValue, time) && !preventUnselect ? void 0 : time;
            if (!isValueControlled) setInternalValue(newValue);
            onValueChange?.(newValue);
        }, [
        currentValue,
        isValueControlled,
        onValueChange,
        preventUnselect
    ]);
    const handleKeyDown = (0, external_react_namespaceObject.useCallback)((e)=>{
        if ('ArrowDown' === e.key) {
            e.preventDefault();
            const nextElement = e.currentTarget.nextElementSibling;
            nextElement?.focus();
        } else if ('ArrowUp' === e.key) {
            e.preventDefault();
            const prevElement = e.currentTarget.previousElementSibling;
            prevElement?.focus();
        }
    }, []);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Menu_index_cjs_namespaceObject.Menu.Root, {
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_Menu_index_cjs_namespaceObject.Menu.Group, {
            tabIndex: -1,
            className: (0, index_cjs_namespaceObject.cn)('w-34 p-1', groupClassName),
            children: [
                timeOptions.map((timeStr)=>{
                    const time = (0, external_utils_cjs_namespaceObject.stringToTime)(timeStr);
                    const selected = (0, external_utils_cjs_namespaceObject.timeIsEqual)(currentValue, time);
                    const itemStyles = (0, external_TimePicker_variants_cjs_namespaceObject.timePickerVariants)({
                        selected
                    });
                    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Menu_index_cjs_namespaceObject.Menu.CheckboxItem, {
                        ref: (element)=>{
                            if (element?.getAttribute('aria-checked') === 'true') setTimeout(()=>{
                                element?.scrollIntoView?.({
                                    behavior: 'instant',
                                    block: 'nearest',
                                    inline: 'nearest'
                                });
                            }, 100);
                        },
                        checked: selected,
                        onCheckedChange: handleTimeSelection(time),
                        checkPosition: "right",
                        className: itemStyles.item(),
                        tabIndex: 1,
                        onKeyDown: handleKeyDown,
                        children: timeStr
                    }, timeStr);
                }),
                endTime.hour === external_utils_cjs_namespaceObject.DEFAULT_END_TIME.hour && endTime.minute === external_utils_cjs_namespaceObject.DEFAULT_END_TIME.minute && endTime.meridiem === external_utils_cjs_namespaceObject.DEFAULT_END_TIME.meridiem && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_Menu_index_cjs_namespaceObject.Menu.CheckboxItem, {
                    checked: (0, external_utils_cjs_namespaceObject.timeIsEqual)(currentValue, endTime),
                    onCheckedChange: handleTimeSelection(endTime),
                    className: (0, external_TimePicker_variants_cjs_namespaceObject.timePickerVariants)({
                        selected: (0, external_utils_cjs_namespaceObject.timeIsEqual)(currentValue, endTime)
                    }).item(),
                    checkPosition: "right",
                    tabIndex: 1,
                    onKeyDown: handleKeyDown,
                    children: [
                        endTime.hour,
                        ":",
                        endTime.minute,
                        " ",
                        endTime.meridiem
                    ]
                }, (0, external_utils_cjs_namespaceObject.timeToString)(endTime))
            ]
        })
    });
};
exports.TimePicker = __webpack_exports__.TimePicker;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "TimePicker"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
